import React from 'react';

interface PriceListRowProps {
  title: string;
  value: string;
  shouldIndicateReducedPrice: boolean;
  isReducedPrice: boolean;
}

const PriceListRow = ({
  title,
  value,
  shouldIndicateReducedPrice,
  isReducedPrice,
}: PriceListRowProps) => (
  <div className={`price-list-row${isReducedPrice ? ' is-reduced' : ''}`}>
    <div className="price-list-label">{title}</div>
    <div className="price-list-value">
      {shouldIndicateReducedPrice && <i className="icon-trend-down text-ui-danger m-r-half" />}
      {value}
    </div>
  </div>
);

export default PriceListRow;
